import { Dispatch } from "react";
import API from "../../services/api";
import { Group } from "typings";
import { createStatusMessage } from "../ui/StatusMessage";
import { statusAdd } from "../ui/action";

export interface LoadGroupsAction
{
    type: "LOAD_GROUPS_SUCCESS";
    groups: Group[];
}






export const loadGroups = () => async (dispatch: Dispatch<any>) =>
{
   
    try 
    {
        const groups = await API.group.getGroups();
        const action: LoadGroupsAction = {type: "LOAD_GROUPS_SUCCESS", groups};
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading groups failed", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export type GroupActions = LoadGroupsAction;


// WEBPACK FOOTER //
// ./src/state/group/action.ts